var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.385 2.27258H8.765C10.175 2.27258 11.305 3.42258 11.305 4.83358V8.24258C11.305 9.66258 10.175 10.8026 8.765 10.8026H5.385C3.985 10.8026 2.845 9.66258 2.845 8.24258V4.83358C2.845 3.42258 3.985 2.27258 5.385 2.27258ZM5.385 13.7423H8.765C10.175 13.7423 11.305 14.8833 11.305 16.3033V19.7123C11.305 21.1223 10.175 22.2723 8.765 22.2723H5.385C3.985 22.2723 2.845 21.1223 2.845 19.7123V16.3033C2.845 14.8833 3.985 13.7423 5.385 13.7423ZM20.3051 2.27258H16.9251C15.5151 2.27258 14.3851 3.42258 14.3851 4.83358V8.24258C14.3851 9.66258 15.5151 10.8026 16.9251 10.8026H20.3051C21.7051 10.8026 22.8451 9.66258 22.8451 8.24258V4.83358C22.8451 3.42258 21.7051 2.27258 20.3051 2.27258ZM16.9251 13.7423H20.3051C21.7051 13.7423 22.8451 14.8833 22.8451 16.3033V19.7123C22.8451 21.1223 21.7051 22.2723 20.3051 22.2723H16.9251C15.5151 22.2723 14.3851 21.1223 14.3851 19.7123V16.3033C14.3851 14.8833 15.5151 13.7423 16.9251 13.7423Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.49a3eda6cbc3b2c0d463a9dd3a85f603.svg";
export { ForwardRef as ReactComponent };